<template>
    <div class="companyMap">
        <div class="titleWrap">
            <indexTitle :title="title" :more="false"></indexTitle>
        </div>
        <div id="map-container" class="mapCenter">
            <svg ref="svgRef"></svg>
        </div>
    </div>
</template>

<script>
import indexTitle from "@/components/c/indexTitle.vue"
import * as d3 from 'd3'
import * as topojson from 'topojson'
export default {
    components: {
        indexTitle,
    },

    props: {
        locations: {
            type: Array,
            default: (() => []),
        },
        title: {
            type: String,
            default: ''
        },
        // locations 格式
        // locations: [
        //     { lat: 39.9042, lon: 116.4074, name: '北京', icon: 'https://wy-wy.oss-cn-beijing.aliyuncs.com/20241228024758/%E7%9F%A2%E9%87%8F%E6%99%BA%E8%83%BD%E5%AF%B9%E8%B1%A1%402x%20(8).png' },
        //     { lat: -33.8688, lon: 151.2093, name: '悉尼', icon: '' }
        // ],
    },
    data() {
        return {
            svg: null,
            projection: null,
        }
    },
    created() {

    },
    mounted() {
        this.initMap()
    },
    watch: {
        locations(newVal, oldVal) {
            this.addMarkers(newVal)
        },
    },
    methods: {
        initMap() {
            // 创建莫卡托投影
            const projection = d3.geoMercator().scale(185).translate([550, 530]);
            this.projection = projection

            // 创建地理路径生成器
            const path = d3.geoPath().projection(projection);
            // 用于存储标记点的位置等信息，这里模拟一些示例数据，可替换为真实数据
            const svg = d3.select(document.getElementById('map-container').querySelector('svg'))
                .attr('width', '100%')
                .attr('height', '100%')
                .attr('preserveAspectRatio', 'xMidYMid meet');
            svg.style('background-color', '#ECECEC');
            this.svg = svg
            // 加载世界地图的地理数据，这里使用TopoJSON格式示例，你也可以使用GeoJSON等其他格式
            d3.json('/map.json')
                .then((topology) => {
                    const countries = topojson.feature(topology, topology.objects.countries);
                    const mapGroup = svg.append('g').attr('class', 'mapGroup');
                    // 绘制世界地图的路径
                    mapGroup.selectAll('path')
                        .data(countries.features)
                        .enter()
                        .append('path')
                        .attr('d', path)
                        .attr('class', 'country')
                        .attr('fill', '#ffffff');
                    // 根据绘制后的实际范围设置 viewBox，使地图随容器自适应缩放（避免窄屏被裁切）
                    const b = mapGroup.node().getBBox();
                    svg.attr('viewBox', `${b.x} ${b.y} ${b.width} ${b.height}`);
                    if (this.locations.length) {
                        this.addMarkers(this.locations)
                    }
                });
        },
        addMarkers(locations) {
            let svg = this.svg
            let projection = this.projection
            if (this.markerGroup) {
                this.markerGroup.remove();
            }
            const markerGroup = svg.append('g').attr('class', 'markerGroup');
            this.markerGroup = markerGroup;
            locations.forEach(location => {
                const [x, y] = projection([location.lon, location.lat]);
                // 根据图标类型绘制不同形状的标记点（这里简单示例圆形和方形，可扩展更多）
                let markerShape;
                if (location.icon) {
                    markerShape = markerGroup.append('image')
                        .attr('x', x - 10) // 根据图片大小调整x坐标偏移量，这里假设图片宽度为20px左右
                        .attr('y', y - 10) // 根据图片大小调整y坐标偏移量，这里假设图片高度为20px左右
                        .attr('width', 20)
                        .attr('height', 20)
                        .attr('href', location.icon);
                } else {
                    markerShape = markerGroup.append('circle')
                        .attr('cx', x)
                        .attr('cy', y)
                        .attr('r', 5)
                        .attr('class', 'marker');
                }
                // if (location.icon === 'circle') {
                //     markerShape = markerGroup.append('circle')
                //         .attr('cx', x)
                //         .attr('cy', y)
                //         .attr('r', 5)
                //         .attr('class', 'marker');
                // } else if (location.icon === 'square') {
                //     markerShape = markerGroup.append('rect')
                //         .attr('x', x - 3)
                //         .attr('y', y - 3)
                //         .attr('width', 6)
                //         .attr('height', 6)
                //         .attr('class', 'marker');
                // }
                // 添加标记点的文字说明
                markerGroup.append('text')
                    .attr('x', x - 15)
                    .attr('y', y - 15)
                    .text(location.name)
                    .attr('class', 'marker-text');
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.companyMap {
    width: 100%;
    background: #ECECEC;
    padding: 80px 0;

    .titleWrap {
        width: 1200px;
        margin: auto;
    }

    .mapCenter {
        width: 1200px;
        margin: auto;
        height: 700px;
    }

    @media screen and (max-width:1200px) {
        .titleWrap {
            width: 100%;
            padding: 0 15px;
            box-sizing: border-box;
        }

        .mapCenter {
            width: 100%;
            height: 400px;
            padding: 0 15px;
            box-sizing: border-box;
        }
    }
}
</style>